/**
 * AI Check-in Route
 *
 * Full-screen CopilotKit-powered AI chat interface for pain tracking.
 * Protected route under _authenticated layout.
 *
 * Uses CopilotPainChat component with useCopilotPainActions hook
 * to provide natural language pain logging via CopilotKit.
 *
 * Per Phase 3.4.7 CopilotKit Integration:
 * - Uses CopilotChat from @copilotkit/react-ui
 * - Integrates frontend tools for pain entry, medication, events
 * - Applies Floline branding (teal theme)
 *
 * @see specs/02_core_user_journeys.md
 */

import { createFileRoute } from "@tanstack/react-router";
import { CopilotPainChat } from "@/components/copilot";

// ============================================================================
// Component
// ============================================================================

/**
 * AI Check-in Page
 *
 * Renders the full-screen CopilotPainChat component.
 * Navigation is handled within the component.
 */
function AICheckInPage() {
  return <CopilotPainChat />;
}

// ============================================================================
// Route Definition
// ============================================================================

export const Route = createFileRoute("/_authenticated/ai-check-in")({
  component: AICheckInPage,
});
